export const token_addresses = {
  customTokenAddress:"0x2F11f02eAB7b981958fe3eA0AF69336323e6070d",
  composerAddress:"0x884715B710a81F4542dD6632BB3769D1308eB451",
  registryAddress:"0x55eEa354443b40d504b433ABA2fdd4eef8F53A89"
}
